export default __webpack_public_path__ + "static/media/empty_cart.4427af20.svg";